import {Action, ActionCreator} from "redux";

/**
 * All action types and physical actions for the results section of postshop locator
 *
 * @author MaxT
 */

export const enum LocatorResultsActionType {
  SET_FILTER = "@@postshop-locator-filter/SET_FILTER",
}

export interface SetFilterAction extends Action {
  type: LocatorResultsActionType.SET_FILTER;
  payload: {
    selectedFilter: string
  }
}

export namespace locatorFilterActions {
  /**
   * On keydown, or value selection. Kick off a search request.
   * @param value
   */
  export const setFilterRequested: ActionCreator<SetFilterAction> = (selectedFilter: string) => ({
    type: LocatorResultsActionType.SET_FILTER,
    payload: {
      selectedFilter: selectedFilter
    }
  });

}

export type LocatorFilterActions =
  SetFilterAction;


// WEBPACK FOOTER //
// ./src/redux/actions/postshop-locator/locatorFilterActions.tsx